<h1>Bulldogs are great</h1>
<p>We really like bulldogs beause they have such an abrasive personality and polished looks</p>

<span *ngFor="let photo of photos">
    <img style="width: 200px;" src="{{photo}}" />
</span>